const MigrationBuildingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M9.99998 8.33322H10.0083M9.99998 11.6668H10.0083M9.99998 4.99962H10.0083M13.333 8.33322H13.3413M13.333 11.6668H13.3413M13.333 4.99962H13.3413M6.66698 8.33322H6.67532M6.66698 11.6668H6.67532M6.66698 4.99962H6.67532M7.50023 18.334V15.8338C7.50023 15.6128 7.58802 15.4008 7.74429 15.2445C7.90055 15.0882 8.11249 15.0004 8.33348 15.0004H11.6665C11.8875 15.0004 12.0994 15.0882 12.2557 15.2445C12.4119 15.4008 12.4997 15.6128 12.4997 15.8338V18.334M5.00048 1.66602H14.9995C15.9199 1.66602 16.666 2.41227 16.666 3.33282V16.6672C16.666 17.5878 15.9199 18.334 14.9995 18.334H5.00048C4.0801 18.334 3.33398 17.5878 3.33398 16.6672V3.33282C3.33398 2.41227 4.0801 1.66602 5.00048 1.66602Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default MigrationBuildingIcon;
